import React from 'react';

const IconOpenPlantsResult = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="auto"
      height="26"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5886 8.25451C19.1768 8.67243 18.9459 8.90673 18.5341 9.32465C18.5653 9.59291 18.5814 9.86598 18.5814 10.143C18.5814 13.2275 16.5041 15.9343 13.5454 16.8156V18.1375C17.9519 17.0674 20.6587 12.661 19.5886 8.25451Z"
        fill="currentColor"
      />
      <path
        d="M11.657 1.95959C7.12462 1.95959 3.47357 5.61065 3.47357 10.143C3.47357 14.4235 6.80988 17.9487 11.0275 18.2634V21.4109C11.0275 21.7886 11.2793 22.0404 11.657 22.0404C12.0347 22.0404 12.2865 21.7886 12.2865 21.4109V14.7383V8.82105L10.2091 6.74373C9.95734 6.49194 9.57964 6.49194 9.32785 6.74373C9.07605 6.99553 9.07605 7.37322 9.32785 7.62502L11.0275 9.32465V13.2275L8.6354 10.8354C8.38361 10.5836 8.00591 10.5836 7.75412 10.8354C7.50232 11.0872 7.50232 11.4649 7.75412 11.7167L11.0275 14.9901V17.0044C7.50232 16.6897 4.73256 13.7311 4.73256 10.143C4.73256 6.30309 7.81706 3.21858 11.657 3.21858C12.8055 3.21858 13.8865 3.49455 14.8376 3.98417L15.7428 3.05636C14.533 2.35401 13.1335 1.95959 11.657 1.95959Z"
        fill="currentColor"
      />
      <path
        d="M20.6767 2.7547H17.2547C16.9636 2.7547 16.8213 3.10402 17.0283 3.30455L18.2832 4.5595L13.2375 9.60517C13.1777 9.66506 13.1302 9.73616 13.0977 9.81441C13.0653 9.89266 13.0486 9.97652 13.0486 10.0612C13.0486 10.1459 13.0653 10.2298 13.0977 10.308C13.1302 10.3863 13.1777 10.4574 13.2375 10.5173C13.2974 10.5772 13.3685 10.6247 13.4468 10.6571C13.525 10.6895 13.6089 10.7062 13.6936 10.7062C13.7783 10.7062 13.8622 10.6895 13.9404 10.6571C14.0187 10.6247 14.0898 10.5772 14.1496 10.5173L19.1889 5.47807L20.4438 6.73302C20.6508 6.93355 21.0001 6.79124 21.0001 6.50014V3.07814C21.0001 2.89701 20.8578 2.7547 20.6767 2.7547Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default IconOpenPlantsResult;
